
import { TRACKING_STATUS_COLLECT, TRACKING_STATUS_LOCKER, TRACKING_STATUS_ORDER } from '@/constants'
import { dateHelper } from '@/helpers/dateHelper'
import { StatusItemVue } from '@/types'
import Vue from 'vue'

export default Vue.extend({
  name: 'timeline-tracking',
  props: {
    selectedStatus: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      TRACKING_STATUS_ORDER,
      TRACKING_STATUS_COLLECT,
      TRACKING_STATUS_LOCKER,
      dateHelper,
    }
  },
  methods: {
    getClassSelectedStatusItem(statusItem: StatusItemVue): string {
      if (!statusItem.date) {
        return ''
      }

      const { status } = statusItem

      if (
        [
          TRACKING_STATUS_ORDER.RETURNED_TO_SENDER,
          TRACKING_STATUS_ORDER.ORDER_DELIVERY_CANCELED,
        ].includes(status)
      ) {
        return 'icon-warning'
      }

      if (
        [
          TRACKING_STATUS_ORDER.ORDER_VALIDATED,
          TRACKING_STATUS_ORDER.APPOINTMENT_SCHEDULING,
          TRACKING_STATUS_ORDER.CARRIER_SUPPORT,
          TRACKING_STATUS_ORDER.DELIVERY_IN_TRANSIT,
          TRACKING_STATUS_ORDER.DELIVERY_AT_DROP_OFF_LOCATION,
          TRACKING_STATUS_ORDER.DELIVERY_ON_GOING,
          TRACKING_STATUS_ORDER.DELIVERY_AVAILABLE,
          TRACKING_STATUS_ORDER.ORDER_DELIVERED,
          TRACKING_STATUS_ORDER.ORDER_IN_PICKUP_POINT,
          TRACKING_STATUS_COLLECT.COLLECT_VALIDATED,
          TRACKING_STATUS_COLLECT.COLLECT_READY,
          TRACKING_STATUS_COLLECT.COLLECT_DELIVERED,
          TRACKING_STATUS_LOCKER.BOOKING_DELIVERED,
          TRACKING_STATUS_LOCKER.BOOKING_READY,
          TRACKING_STATUS_LOCKER.BOOKING_VALIDATED,
        ].includes(status)
      ) {
        return 'icon-success'
      } else {
        return 'icon-error'
      }
    },
  },
})
